import React, { useEffect, useRef, useState } from "react";
import styles from "./Pending.module.css";
import { SearchInput, TextComponent } from "../../../../../components";
import { List, Skeleton } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { EventPlanningMiddleware } from "../../../../../Store/Middlewares/EventPlanningMiddleware";
const Pending = () => {
  const Pending = useSelector((state) => state.EventPlanningReducer.Pending);

  const EventDetails = useSelector((state) => state.EventReducer.EventDetails);
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const searchRef = useRef();

  useEffect(() => {
    dispatch(
      EventPlanningMiddleware.eventPendingGuest({
        id: EventDetails?.id,
        status: "rsvp_sent",
      })
    )
      .then(() => setLoading(false))
      .catch(() => setLoading(false));
  }, []);

  const onSearch = (name) => {
    clearTimeout(searchRef.current);
    searchRef.current = setTimeout(() => {
      dispatch(
        EventPlanningMiddleware.eventPendingGuest({
          id: EventDetails?.id,
          status: "rsvp_sent",
          name,
        })
      )
        .then(() => {
          setLoading(false);
        })
        .catch(() => setLoading(false));
    }, 500);
  };

  return (
    <div className={styles.mainCont}>
      <div className={styles.search}>
        <SearchInput
          placeholder={"Search"}
          onChange={(e) => onSearch(e.target.value)}
        />
      </div>
      <Skeleton loading={loading}>
        <List
          dataSource={Pending}
          className={styles.list}
          renderItem={(item, index) => {
            return (
              <div className={styles.listItem} key={index}>
                <TextComponent text={item?.name} textClass={styles.listname} />
                <TextComponent text={"Sent"} textClass={styles.liststatus} />
              </div>
            );
          }}
        />
      </Skeleton>
    </div>
  );
};

export default Pending;
